import React from 'react';
import { BaseActions } from './components/BaseActions/BaseActions';
import { FidelityActions } from './components/FidelityActions/FidelityActions';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { AuthenticationAuthorityDTO, ProviderType } from '../../DocumentVault.meta';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Feature } from '../../../CommonSelectors/CommonArea.types';
import { SearchActions } from './components/SearchActions/SearchActions';
import { useRouteParams } from '../../hooks/useRouteParams';

export const BrowserHeaderActions = () => {
  const { selectedEntity } = useDocumentVaultContext();
  const { providerType } = useRouteParams();

  const showSearchBox = useFeatureFlag(Feature.DocumentVaultSearch);

  return (
    <>
      {showSearchBox && providerType !== ProviderType.External && <SearchActions />}
      <BaseActions />
      {selectedEntity?.authenticationAuthority === AuthenticationAuthorityDTO.FidelityDocuments && (
        <FidelityActions />
      )}
    </>
  );
};
